import NewUserModal from './NewUserModal'

export default NewUserModal
